





















































import {
  defineComponent,
  PropType,
  vue3Model,
  onMounted,
  ref
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SWIFT } from '~/constants/debounce'
import { ciEyeDropper } from '~/icons/source/solid/eye-dropper'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: String,
      required: true
    },
    options: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  setup(_, { emit }) {
    const supportsColorInput = ref(false)

    onMounted(() => {
      const input = document.createElement('input')
      input.setAttribute('type', 'color')
      supportsColorInput.value = input.type === 'color'
    })

    const selectColor = debounce((color: string) => {
      emit('update:modelValue', color)
    }, DEBOUNCE_SWIFT)

    return { selectColor, supportsColorInput, ciEyeDropper }
  },
  i18n: defineComponentTranslations({
    select_background: {
      en: 'Select background',
      el: 'Επιλογή φόντου'
    }
  })
})
